import React from "react";
import { ExternalLink } from "react-feather";
import {
  ClickableLabel,
  ExternalLinkButton,
  FocusLinkButton,
  Label,
  Row,
} from "./KgInspectorLinkRow.styles";
import type { KgInspectorLinkRowProps } from "./KgInspectorLinkRow.types";

export const KgInspectorLinkRow: React.FC<KgInspectorLinkRowProps> = ({
  label,
  onFocusClick,
  externalUrl,
}) => (
  <Row>
    {onFocusClick ? (
      <ClickableLabel type="button" onClick={onFocusClick}>
        {label}
      </ClickableLabel>
    ) : (
      <Label>{label}</Label>
    )}
    {onFocusClick ? (
      <FocusLinkButton
        type="button"
        onClick={onFocusClick}
        aria-label={`Show ${label} on graph`}
      >
        <ExternalLink size={14} />
      </FocusLinkButton>
    ) : (
      externalUrl && (
        <ExternalLinkButton
          href={externalUrl}
          target="_blank"
          rel="noreferrer"
          aria-label={`Open ${label} in a new tab`}
        >
          <ExternalLink size={14} />
        </ExternalLinkButton>
      )
    )}
  </Row>
);

export default KgInspectorLinkRow;
